import 'core-js/es6/string';
import 'core-js/es6/array';
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/es6/object';
import 'core-js/es6/promise';
import 'core-js/es7/object';
import 'core-js/es7/array';
import 'raf/polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import config from './helper/Config';
import ls from 'localstorage-slim';
const STORAGE_KEY = `/${config.BASE_PATH}`;

import App from './App';

import './i18n';

import configureStore from './store/store';
const store = configureStore();
const rawState = ls.get(STORAGE_KEY, { decrypt: true });
const state = JSON.parse(rawState || '{}')
    
/*
    web will be deployed in IIS Server.
    in server, iis will manipulate url by using query string
    so, need to tweak the url to get latest page when website reloaded
*/
let search = location.search;
let params = new URLSearchParams(search);
let path = params.get('path')
let requestid = params.get('requestid')

if (path?.includes('resetpassword')) {
    let key = params.get('key');
    let userName = params.get('username');
    let urlDes = `${path}?key=${key}&username=${userName}`;
    history.pushState({}, null, urlDes);
}
else if(requestid || !state?.user?.userInfo?.userName){
    path=`login?${params.toString()}`
}
else if(path?.includes('login')) path='home'
// if(!location?.pathname?.includes('/resetpassword') || !location?.pathname?.includes('/unauthorized'))
//     history.pushState({}, null, path);

if(!location?.pathname?.includes('/unauthorized') && !location?.pathname?.includes('/resetpassword'))
    history.pushState({}, null, path);

// if(location?.pathname?.includes('/resetpassword'))
// {
//     let key = params.get('key');
//     let userName = params.get('username');
//     let urlDes = `${path}?key=${key}&username=${userName}`;
//     history.pushState({}, null, urlDes);
// }
// if (!location?.pathname?.includes('resetpassword') && !location?.pathname?.includes('/unauthorized')) {
//         history.pushState({}, null, path);
// }
    


// if(requestid || !state?.user?.userInfo?.userName){
//     path=`login?${params.toString()}`
// }
// else if(path?.includes('login')) 
// {
//         path='home'
// }


ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('app')
);
